export enum ShareableEntityType {
  NONE = 'NONE',
  LIST = 'LIST',
  ANNOTATIONS = 'ANNOTATION',
  RECORDING = 'RECORDING',
  PLAYLIST = 'PLAYLIST',
}
